import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import Home from './components/home';
import About from './components/about';
import Proyects from './components/proyects';
import Contact from './components/contact';


const router = createBrowserRouter([
  {
    path:'/',
    element:<Home/>,
    errorElement:<h1>Error Intentelo mas tarde</h1>
  },
  {
    path:'/about',
    element:<About/>
  },
  {
    path: '/proyects',
    element:<Proyects/>
  },
  {
    path:'/contact',
    element:<Contact/>
  }
])
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);


